import { ready } from '~/core';

ready('accordion', '.accordion-item', item => {
	const trigger = item.querySelector('.accordion-trigger');
	const contents = item.querySelector('.accordion-content');

	const toggle = e => {
		let start, end, duration;
		start = contents.offsetHeight;
		trigger.classList.toggle('is-active');
    contents.classList.toggle('is-active');
		end = contents.offsetHeight;

		duration = Math.abs(start - end) > 500 ? 500 : 250;

		contents.animate([{ height: `${start}px` }, { height: `${end}px` }], {
			duration,
			easing: 'ease',
		});

		if (item.classList.contains('is-active')) {
			setTimeout(() => {
				window.scrollTo({
					top: item.offsetTop,
					behavior: 'smooth',
				});
			}, duration / 2);
		}
	};
  if(trigger !== null){
	  trigger.addEventListener('click', toggle);
  }

  let accordionFirstChild;
  accordionFirstChild = document.querySelectorAll(".accordion--subSearchResult");
  for (let i = 0; i < accordionFirstChild.length; ++i) {
    let accordTrigger = accordionFirstChild[i].getElementsByClassName('accordion-trigger')[0];
    let accordContent = accordionFirstChild[i].getElementsByClassName('accordion-content')[0];
    accordContent.classList.add('is-active');
    accordTrigger.classList.add('is-active');
  } 
});
